import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { getGlobalStyleSheets } from '../../global-styles';
import {
   AtlStatusIndicatorProps,
   AtlStatusIndicatorTagNames,
} from './status-indicator.props';
import {
   enumAttributeConverter,
   Variant,
   VariantValuesMap,
} from '../enum-types';
import { IconSet, IconSizes, IconSource } from '../icon/icon.props';
import {
   SpinnerSize,
   SpinnerAlignment,
   SpinnerVariant,
} from '../spinner/props';
import { AtlIconTemplate } from '../icon/icon.component';

@customElement(AtlStatusIndicatorTagNames.StatusIndicator)
export class AtlStatusIndicator
   extends LitElement
   implements AtlStatusIndicatorProps
{
   declare reverseOrder?: boolean;
   declare variant?: Variant;
   declare icon?: string;
   declare size?: IconSizes;
   declare iconSet?: IconSet;
   declare loading?: boolean;

   static properties = {
      reverseOrder: { attribute: 'reverse-order', type: Boolean },
      variant: { type: String, converter: enumAttributeConverter(Variant) },
      icon: { type: String },
      size: { type: String, converter: enumAttributeConverter(IconSizes) },
      iconSet: { type: String, converter: enumAttributeConverter(IconSet) },
      loading: { type: Boolean, state: true },
   };

   static styles = [
      ...getGlobalStyleSheets(),
      css`
         atlantis-icon {
            display: block;
         }
      `,
   ];

   renderIcon() {
      if (this.loading) {
         return html`
            <atlantis-inline-loader
               size=${SpinnerSize.small}
               align=${SpinnerAlignment.Middle}
               color=${SpinnerVariant.Primary}
            >
            </atlantis-inline-loader>
         `;
      }

      const variant = this.variant || Variant.Primary;

      return AtlIconTemplate({
         iconSource: IconSource.FontAwesome,
         iconName: this.icon ?? 'circle',
         iconSize: this.size ?? IconSizes.ExtraSmaller,
         iconSet: this.iconSet ?? IconSet.Solid,
         iconClassNames: `text-${VariantValuesMap[variant]}`,
      });
   }

   render() {
      const classNames = ['flex', 'align-items-center'];

      if (this.reverseOrder) {
         classNames.push('flex-row-reverse');
      }

      return html`
         <div class=${classNames.join(' ')}>
            ${this.renderIcon()}
            <slot></slot>
         </div>
      `;
   }
}
